module.exports = __webpack_public_path__ + "img/Eduzz-9-es.e29ca9ab.png";